import styled, { createGlobalStyle } from 'styled-components';

import { LAYOUT_CHROME, NAV_DESKTOP } from '../../theme/tokens';
import { CUST, CUST_FONT, CUST_GRADIENTS } from '../../theme/customizer-tokens';

/**
 * Wizard document backdrop. Same idea as MainLayout's `StudioBackdrop`: while the
 * customizer is mounted, paint the whole document (html / body / #root) with the
 * themed wizard page background so the config-engine's own dark body background
 * can't show through — behind the `Root` on ultrawide screens (it's capped at
 * 1920px) or in any overscroll gap. Unmounts with the layout, restoring the
 * config shell's background for the config-driven pages. Dark = the same near-black
 * as before; light = the off-white page. */
export const CustomizerBackdrop = createGlobalStyle`
  html,
  body,
  #root {
    background: ${CUST.pageBg} !important;
  }
`;

/**
 * Full-viewport root for the customizer wizard. Owns the dark page background
 * (the Figma vignette darkening the edges) and the brand font; lays the app side
 * rail beside the wizard content. Unlike `MainLayout` it ships NO top bar / Lumio
 * column — the wizard provides its own header (see WizardHeader).
 */
export const Root = styled.div`
  /* Same container constraint as MainLayout: capped at 1920px and centred. */
  width: 100dvw;
  height: 100dvh;
  max-width: ${LAYOUT_CHROME.maxWidth};
  margin: 0 auto;
  display: flex;
  overflow: hidden;
  background-color: ${CUST.pageBg};
  background-image: ${CUST_GRADIENTS.pageVignette};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: ${CUST.white};
  font-family: ${CUST_FONT};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${NAV_DESKTOP} {
    padding: ${LAYOUT_CHROME.pad};
    gap: ${LAYOUT_CHROME.gap};
  }
`;

/** Desktop-only left rail (the shared SideMenu); hidden on the mobile flow. */
export const SideMenuCol = styled.div`
  min-width: ${LAYOUT_CHROME.sideMenuWidth};
  max-width: ${LAYOUT_CHROME.sideMenuWidth};
  position: relative;
  display: none;

  ${NAV_DESKTOP} {
    display: block;
  }
`;

/** The wizard content slot — fills the remaining width, transparent over the
 *  page vignette (the wizard owns its own header/body/footer chrome inside). */
export const Content = styled.main`
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;